module.exports = __webpack_public_path__ + "static/media/04.e73b6989.jpg";